module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/archivar-black.9dc11d04.svg";